import { ScoringInputType } from "./../models/enums/ScoringInputType";
import request from "./api";

export class ScoringService {
  async getScoringDetails(fixtureRoomId: string) {
    const response = await request({
      method: "GET",
      url: `api/fixturerooms/${fixtureRoomId}/scoringdetails`,
    });

    return response;
  }

  async getInputItemList(fixtureRoomId: string) {
    const response = await request({
      method: "GET",
      url: `api/fixturerooms/${fixtureRoomId}/inputitemlist`,
    });

    return response;
  }

  async updateTeamPitchOrigins(
    fixtureRoomId: string,
    firstHalfTeamAtOrigin: string,
    secondHalfTeamAtOrigin: string
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/teampitchorigins`,
      data: { firstHalfTeamAtOrigin, secondHalfTeamAtOrigin },
    });

    return response;
  }
  
  async startNewClip(
    fixtureRoomId: string,
    time: number,
    restartTeam: string,
    restartReason: number,
    metersX: number,
    metersY: number
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/newclip`,
      data: { time, restartTeam, restartReason, metersX, metersY },
    });

    return response;
  }

  async startNewClipWithWatcherInfo(
    fixtureRoom: string,
    time: number,
    restartTeam: string,
    restartReason: number,
    metersX: number,
    metersY: number
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoom}/newclipwatcherinfo`,
      data: { time, restartTeam, restartReason, metersX, metersY },
    });

    return response;
  }

  async endClip(
    clipId: string,
    time: number,
    endTeam: string,
    endReason: number,
    metersX: number,
    metersY: number,
    penaltyReasonResult: any
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/clips/${clipId}/end`,
      data: { time, endTeam, endReason, metersX, metersY, penaltyReasonResult },
    });

    return response;
  }

  async setEndClipPosition(clipId: string, metersX: number, metersY: number) {
    const response = await request({
      method: "POST",
      url: `api/scoring/clips/${clipId}/endposition`,
      data: { metersX, metersY },
    });

    return response;
  }

  async setStartClipPosition(clipId: string, metersX: number, metersY: number) {
    const response = await request({
      method: "POST",
      url: `api/scoring/clips/${clipId}/startposition`,
      data: { metersX, metersY },
    });

    return response;
  }

  async deleteClip(fixtureRoomId: string, clipId: string, deleteClipEnd: boolean) {
    const response = await request({
      method: "DELETE",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/clip/${clipId}?deleteClipEnd=${deleteClipEnd}`,
    });

    return response;
  }

  async addScore(
    fixtureRoomId: string,
    teamId: string,
    position: number,
    score: number,
    categorizations: any,
    half: number,
    time: number,
    PositionX: number,
    PositionY: number,
    descriptions: any,
    shirtNumber: number
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addscore`,
      data: {
        teamId,
        position,
        score,
        categorizations,
        shirtNumber,
        half,
        time,
        PositionX,
        PositionY,
        descriptions,
      },
    });

    return response;
  }

  async setFirstHalfEnd(fixtureRoom: string, time: number) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoom}/setfirsthalfend`,
      data: { time },
    });

    return response;
  }

  async setSecondHalfEnd(fixtureRoom: string, time: number) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoom}/setsecondhalfend`,
      data: { time },
    });

    return response;
  }

  async deleteScore(fixtureRoomId: string, scoreId: string) {
    const response = await request({
      method: "DELETE",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/playerscore/${scoreId}`,
    });

    return response;
  }

  async deleteCard(fixtureRoomId: string, cardId: string, type: ScoringInputType) {
    const response = await request({
      method: "DELETE",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/playercard/${cardId}/${type}`,
    });

    return response;
  }

  async deleteHalfEnd(fixtureRoomId: string, half: number) {
    const response = await request({
      method: "DELETE",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/deleteHalfEnd/${half}`,
    });

    return response;
  }

  async deleteHalfStart(fixtureRoomId: string, half: number) {
    const response = await request({
      method: "DELETE",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/deleteHalfStart/${half}`,
    });

    return response;
  }

  async exportScores(fixtureRoomId: string) {
    const response = await request({
      method: "GET",
      url: `api/fixturerooms/${fixtureRoomId}/scores/export`,
    });

    return response;
  }

  async addCardScore(
    fixtureRoomId: string,
    teamId: string,
    position: number,
    cardType: number,
    time: number,
    returnedTime: number,
    shirtNumber: number
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addcard`,
      data: { fixtureRoomId, teamId, position, cardType, time, returnedTime, shirtNumber },
    });

    return response;
  }

  async setCardScore(
    fixtureRoomId: string,
    teamId: string,
    position: number,
    cardType: number,
    time: number,
    returnedTime: number,
    shirtNumber: number
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/setcard`,
      data: { fixtureRoomId, teamId, position, cardType, time, returnedTime, shirtNumber },
    });

    return response;
  }

  async addKickScore(
    fixtureRoomId: string,
    clipId: string,
    teamId: string,
    position: number,
    positionX: number,
    positionY: number,
    time: number,
    kickType: number,
    successful: boolean,
    shirtNumber: number
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addkick`,
      data: {
        clipId,
        teamId,
        position,
        positionX,
        positionY,
        time,
        kickType,
        successful,
        shirtNumber,
      },
    });

    return response;
  }

  async addPenaltyKick(
    fixtureRoomId: string,
    teamId: string,
    clipStartTime: number,
    clipEndTime: number,
    KickType: number,
    positionX: number,
    positionY: number,
    shirtNumber: string,
    score: number,
    categorizations: any,
    half: number,
    successful: boolean,
    remainInPlay: boolean
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addpenaltykick`,
      data: {
        fixtureRoomId,
        teamId,
        clipStartTime,
        clipEndTime,
        KickType,
        positionX,
        positionY,
        shirtNumber,
        score,
        categorizations,
        half,
        successful,
        remainInPlay,
      },
    });

    return response;
  }

  async addDropGoal(
    fixtureRoomId: string,
    teamId: string,
    clipId: string,
    clipEndTime: number,
    KickType: number,
    positionX: number,
    positionY: number,
    position: number,
    score: number,
    categorizations: any,
    half: number,
    successful: boolean,
    remainInPlay: boolean,
    shirtNumber: string
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/adddropgoal`,
      data: {
        teamId,
        clipId,
        clipEndTime,
        KickType,
        positionX,
        positionY,
        position,
        score,
        categorizations,
        half,
        successful,
        remainInPlay,
        shirtNumber,
      },
    });

    return response;
  }

  async addConversionKick(
    fixtureRoomId: string,
    teamId: string,
    clipStartTime: number,
    clipEndTime: number,
    KickType: number,
    positionX: number,
    positionY: number,
    shirtNumber: string,
    score: number,
    categorizations: any,
    half: number,
    successful: boolean,
    remainInPlay: boolean
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addconversionkick`,
      data: {
        teamId,
        clipStartTime,
        clipEndTime,
        KickType,
        positionX,
        positionY,
        shirtNumber,
        score,
        categorizations,
        half,
        successful,
      },
    });

    return response;
  }

  async addTeamScore(
    fixtureRoomId: string,
    teamId: string,
    position: number,
    score: number,
    categorizations: any,
    half: number,
    time: number,
    PositionX: number,
    PositionY: number,
    descriptions: any
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addteamscore`,
      data: {
        fixtureRoomId,
        teamId,
        position,
        score,
        categorizations,
        half,
        time,
        PositionX,
        PositionY,
        descriptions,
      },
    });

    return response;
  }

  async adjustMidClip(
    fixtureRoomId: string,
    userEnteredSupremacy: number,
    scoringInputPlayerId: string,
    midClipId: string,
    time: number,
    notes: string
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/clips/${scoringInputPlayerId}/adjmidclip`,
      data: {
        fixtureRoomId,
        userEnteredSupremacy,
        scoringInputPlayerId,
        midClipId,
        time,
        notes,
      },
    });

    return response;
  }

  async deleteTeamScore(fixtureRoomId: string, scoreId: string) {
    const response = await request({
      method: "DELETE",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/teamscore/${scoreId}`,
    });

    return response;
  }

  async deleteMidClip(fixtureRoomId: string, midClipId: string) {
    const response = await request({
      method: "delete",
      url: `api/scoring/clips/${fixtureRoomId}/deletemidclip/${midClipId}`,
      data: { fixtureRoomId, midClipId },
    });

    return response;
  }

  async addGroupScore(
    fixtureRoomId: string,
    multiplePlayersSelectedList: any,
    score: number,
    categorizations: any,
    half: number,
    time: number,
    PositionX: number,
    PositionY: number,
    descriptions: any
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addgroupscore`,
      data: {
        fixtureRoomId,
        multiplePlayersSelectedList,
        score,
        categorizations,
        half,
        time,
        PositionX,
        PositionY,
        descriptions,
      },
    });

    return response;
  }

  async addTryScorer(
    fixtureRoomId: string,
    teamId: string,
    startClipId: string,
    shirtNumber: string,
    positionX: number,
    positionY: number,
    time: number,
    categorizations: any
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${fixtureRoomId}/addtry`,
      data: {
        teamId,
        startClipId,
        shirtNumber,
        positionX,
        positionY,
        time,
        categorizations,
      },
    });

    return response;
  }

  async deleteTryScorer(tryId: string) {
    const response = await request({
      method: "DELETE",
      url: `api/scoring/fixtureroom/try/${tryId}`,
    });

    return response;
  }

  async setPlayerScore(
    playerScoreId: string,
    teamId: string,
    playerShirtNumber: number,
    positionX: number,
    positionY: number,
    score: number,
    categorizations: any,
    descriptions: any,
    fixtureRoomId?: string,
    isTeamScore: boolean = false
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${playerScoreId}/setplayerscore/${playerShirtNumber}`,
      data: {
        playerScoreId,
        teamId,
        playerShirtNumber,
        positionX,
        positionY,
        score,
        categorizations,
        descriptions,
        fixtureRoomId,
        isTeamScore
      },
    });

    return response;
  }

  async exportInput(fixtureId: string) {
    const response = await request({
      method: "GET",
      url: `api/scoring/${fixtureId}/inputs/export`,
    });

    return response;
  }

  async importInput(fixtureId: string, scoringInputListItem: any) {
    const response = await request({
      method: "POST",
      url: `api/scoring/${fixtureId}/inputs/import`,
      data: { scoringInputListItem },
    });

    return response;
  }

  async addPlayerDetail(
    homePlayers: any,
    awayPlayers: any,
    homeTeamId: string,
    awayTeamId: string,
    fixtureId: string
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/${fixtureId}/inputs/addplayerdetail`,
      data: { homeTeamId, awayTeamId, homePlayers, awayPlayers },
    });

    return response;
  }

  async addSinglePlayerDetail(
    fixtureId: string,
    id: string,
    position: string,
    playerName: string,
    teamId: string
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/${fixtureId}/inputs/addsingleplayerdetail`,
      data: { id, position, playerName, teamId },
    });

    return response;
  }

  async updatePlayerDetail(fixtureId: string, playerUpdateList: any) {
    const response = await request({
      method: "POST",
      url: `api/scoring/${fixtureId}/inputs/updateplayerdetail`,
      data: { playerUpdateList },
    });

    return response;
  }

  async importPlayerDetail(
    playerUpdateList: any,
    fixtureId: string,
    isHomeTeam: boolean
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/${fixtureId}/inputs/importplayerdetail`,
      data: { playerUpdateList, isHomeTeam },
    });

    return response;
  }

  async setClipEvent(
    clipId: string,
    positionX: number,
    positionY: number,
    type: number,
    clipSelectedPlayer: string,
    teamId: string,
    matchEventWon: boolean,
    lineoutTargetResult: any,
    freekickResult: any,
    penaltyResult: any,
    penaltyReasonResult: any
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${clipId}/setclip`,
      data: {
        positionX,
        positionY,
        type,
        teamId,
        clipSelectedSquadMember : clipSelectedPlayer?.toString(),
        matchEventWon,
        lineoutTargetResult,
        freekickResult,
        penaltyResult,
        penaltyReasonResult,
      },
    });

    return response;
  }

  async addLineOutInfo(
    clipId: string,
    matchEventWon: boolean,
    lineoutTargetResult: any,
    freekickResult: any
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${clipId}/addlineoutinfo`,
      data: { matchEventWon, lineoutTargetResult, freekickResult },
    });

    return response;
  }

  async addScrumInfo(
    clipId: string,
    matchEventWon: boolean,
    penaltyResult: any,
    freekickResult: any
  ) {
    const response = await request({
      method: "POST",
      url: `api/scoring/fixtureroom/${clipId}/addpscruminfo`,
      data: { matchEventWon, penaltyResult, freekickResult },
    });

    return response;
  }

  async getPlayersInTeam(fixtureId: string) {
    const response = await request({
      method: "GET",
      url: `api/scoring/fixture/${fixtureId}/playersinteam`,
    });

    return response;
  }

  static get instance() {
    return scoringService;
  }
}

const scoringService = new ScoringService();

export default scoringService;
